export const BG = "#0D0E14";
export const SURFACE = "#161B22";
export const CARD_BG = "#161B22";
export const NAV_BG = "#12131A";
// 0.06 is the value every Field Admin design page uses for a card border (188 occurrences
// across the design set; 0.07 appears nowhere in it). Shared with the QE pages, which draw
// on the same dark palette, so the 0.01 shift moves them toward the design too.
export const BORDER = "rgba(255,255,255,0.06)";
export const AMBER = "#FDB940";
export const SUCCESS = "#22C55E";
export const LABEL = "rgba(255,255,255,0.4)";
